import React from "react";
import { Box, IconButton, Typography, Avatar } from "@mui/material";
import { PlayArrow, Pause, SkipNext, SkipPrevious } from "@mui/icons-material";
import { useAudio } from "./AudioProvider"; // adjust path as needed

const BottomBar = () => {
    const { tracks, isPlayingIndex, playTrack, pauseTrack } = useAudio();

    const currentTrack = isPlayingIndex !== null ? tracks[isPlayingIndex] : null;

    const handlePlayPause = () => {
        if (isPlayingIndex !== null) {
            pauseTrack();
        } else if (tracks.length > 0) {
            playTrack(0);
        }
    };

    const handleNext = () => {
        if (isPlayingIndex !== null && tracks.length > 0) {
            const nextIndex = (isPlayingIndex + 1) % tracks.length;
            playTrack(nextIndex);
        }
    };

    const handlePrevious = () => {
        if (isPlayingIndex !== null && tracks.length > 0) {
            const prevIndex = (isPlayingIndex - 1 + tracks.length) % tracks.length;
            playTrack(prevIndex);
        }
    };

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: "#1C1C1C",
                color: "lightgray",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                px: 3,
                py: 1.5,
                boxShadow: 3,
                zIndex: 1000,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {currentTrack?.imageUrl ? (
                    <Avatar
                        variant="rounded"
                        src={currentTrack.imageUrl}
                        alt={currentTrack.title}
                        sx={{ width: 56, height: 56 }}
                    />
                ) : (
                    <Avatar
                        variant="rounded"
                        sx={{ width: 56, height: 56, bgcolor: "#333" }}
                    >
                        ♫
                    </Avatar>
                )}
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontSize: "20px",
                        color: "#9CA3AF",
                        overflow: "hidden",
                        maxWidth: "200px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                    }}
                >
                    {currentTrack?.title || "No track selected"}
                </Typography>
            </Box>

            <Box>
                <IconButton onClick={handlePrevious}>
                    <SkipPrevious sx={{ color: "#9CA3AF", fontSize: "35px" }} />
                </IconButton>
                <IconButton onClick={handlePlayPause}>
                    {isPlayingIndex !== null ? (
                        <Pause sx={{ color: "#9CA3AF", fontSize: "35px" }} />
                    ) : (
                        <PlayArrow sx={{ color: "#9CA3AF", fontSize: "35px" }} />
                    )}
                </IconButton>
                <IconButton onClick={handleNext}>
                    <SkipNext sx={{ color: "#9CA3AF", fontSize: "35px" }} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default BottomBar;
